(function() {
  'use strict';

  window.ecInstitutionalTabs = window.ecInstitutionalTabs || {
    tabs: {},
    register: function(blockId, data) {
      this.tabs[blockId] = data;
    },
    getAll: function() {
      return this.tabs;
    }
  };

  function getSidebarSectionLabel(sectionEl, sectionKey) {
    if (!sectionKey) return '';

    const keyMatch = sectionKey.match(/^section_(\d+)$/);
    if (!keyMatch) return sectionKey;

    const index = keyMatch[1];
    const label = sectionEl.dataset['sidebarSection' + index];

    if (label && label.trim()) return label.trim();

    return 'Seção ' + index;
  }

  function getPanelSidebarTitle(panel, sectionEl, tabData) {
    const groupElement = panel.closest('.ec-institutional-tabs__sidebar-group');

    if (groupElement) {
      const groupTitle = groupElement.dataset.sidebarGroupTitle;
      if (groupTitle && groupTitle.trim()) {
        return groupTitle.trim();
      }
    }

    if (tabData && tabData.sidebarSection) {
      return getSidebarSectionLabel(sectionEl, tabData.sidebarSection);
    }

    return 'Seção';
  }

  function initInstitutionalTabs() {
    const sections = document.querySelectorAll('.ec-institutional-tabs');
    
    sections.forEach(function(section) {
      if (section.hasAttribute('data-initialized')) {
        return;
      }
      
      section.setAttribute('data-initialized', 'true');
      
      const sidebar = section.querySelector('.ec-institutional-tabs__sidebar');
      const content = section.querySelector('.ec-institutional-tabs__content');
      
      if (!sidebar || !content) return;
      
      const tabPanels = content.querySelectorAll('.ec-institutional-tabs__tab-content');
      
      if (!tabPanels.length) return;
      
      sidebar.innerHTML = '';
      
      const tabs = window.ecInstitutionalTabs.getAll();
      
      let currentSidebarSection = '';
      let sectionCounter = 0;

      tabPanels.forEach(function(panel, index) {
        const blockId = panel.getAttribute('data-tab-id');
        const tabData = tabs[blockId] || {};
        const title = tabData.title || 'Tab ' + (index + 1);
        const icon = tabData.icon;
        const sidebarSectionTitle = getPanelSidebarTitle(panel, section, tabData);

        if (sidebarSectionTitle !== currentSidebarSection) {
          const sectionTitle = document.createElement('p');
          sectionTitle.className = 'ec-institutional-tabs__sidebar-section-title';

          if (sectionCounter > 0) {
            sectionTitle.classList.add('is-not-first');
          }

          sectionTitle.textContent = sidebarSectionTitle;
          sidebar.appendChild(sectionTitle);
          currentSidebarSection = sidebarSectionTitle;
          sectionCounter += 1;
        }
        
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ec-institutional-tabs__tab-button';
        btn.setAttribute('data-tab-target', blockId);
        
        if (icon && icon.trim()) {
          const img = document.createElement('img');
          img.src = icon;
          img.alt = title;
          img.className = 'tab-icon';
          btn.appendChild(img);
        }
        
        const span = document.createElement('span');
        span.textContent = title;
        btn.appendChild(span);
        
        if (index === 0) {
          btn.classList.add('active');
          panel.classList.add('active');
        }
        
        btn.addEventListener('click', function() {
          handleTabChange(blockId, section);
        });
        
        sidebar.appendChild(btn);
      });

      initMobileDropdown(section, tabPanels, tabs);
    });
  }

  function initMobileDropdown(section, tabPanels, tabs) {
    const mobileSelector = section.querySelector('.ec-institutional-tabs__mobile-selector');
    const trigger = section.querySelector('.ec-institutional-tabs__dropdown-trigger');
    const menu = section.querySelector('.ec-institutional-tabs__dropdown-menu');
    const content = section.querySelector('.ec-institutional-tabs__content');
    
    if (!trigger || !menu) return;
    
    menu.innerHTML = '';
    
    tabPanels.forEach(function(panel, index) {
      const blockId = panel.getAttribute('data-tab-id');
      const tabData = tabs[blockId] || {};
      const title = tabData.title || 'Tab ' + (index + 1);
      const icon = tabData.icon;
      
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'ec-institutional-tabs__dropdown-item';
      item.setAttribute('data-tab-target', blockId);
      
      const span = document.createElement('span');
      span.textContent = title;
      item.appendChild(span);
      
      if (index === 0) {
        item.classList.add('active');
      }
      
      item.addEventListener('click', function() {
        handleTabChange(blockId, section);
        closeMobileDropdown(trigger, menu);
      });
      
      menu.appendChild(item);
    });
    
    const label = section.querySelector('.ec-institutional-tabs__dropdown-label');
    if (label && tabPanels.length > 0) {
      const firstId = tabPanels[0].getAttribute('data-tab-id');
      const firstData = tabs[firstId] || {};
      label.textContent = firstData.title || 'Tab 1';
    }
    
    trigger.addEventListener('click', function() {
      trigger.classList.toggle('active');
      menu.classList.toggle('active');
    });
    
    document.addEventListener('click', function(e) {
      if (!mobileSelector.contains(e.target)) {
        closeMobileDropdown(trigger, menu);
      }
    });
  }

  function generateSlug(text) {
    if (!text) return '';
    
    // Mapear caracteres acentuados para não-acentuados
    const accentsMap = {
      'á': 'a', 'à': 'a', 'ã': 'a', 'â': 'a', 'ä': 'a',
      'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
      'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i',
      'ó': 'o', 'ò': 'o', 'õ': 'o', 'ô': 'o', 'ö': 'o',
      'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
      'ç': 'c', 'ñ': 'n'
    };
    
    return text
      .toLowerCase()
      .replace(/[áàãâäéèêëíìîïóòõôöúùûüçñ]/g, function(char) {
        return accentsMap[char] || char;
      })
      .replace(/[^\w\s-]/g, '') // Remover caracteres especiais
      .replace(/\s+/g, '-') // Trocar espaços por hífens
      .replace(/-+/g, '-') // Remover hífens duplicados
      .replace(/^-+|-+$/g, ''); // Remover hífens do início/fim
  }

  function handleTabChange(blockId, section, updateHash) {
    const sidebar = section.querySelector('.ec-institutional-tabs__sidebar');
    const content = section.querySelector('.ec-institutional-tabs__content');
    const menu = section.querySelector('.ec-institutional-tabs__dropdown-menu');
    const label = section.querySelector('.ec-institutional-tabs__dropdown-label');
    
    sidebar.querySelectorAll('.ec-institutional-tabs__tab-button').forEach(function(btn) {
      btn.classList.remove('active');
    });
    
    if (menu) {
      menu.querySelectorAll('.ec-institutional-tabs__dropdown-item').forEach(function(item) {
        item.classList.remove('active');
      });
    }
    
    content.querySelectorAll('.ec-institutional-tabs__tab-content').forEach(function(p) {
      p.classList.remove('active');
    });
    
    const activeBtn = sidebar.querySelector('[data-tab-target="' + blockId + '"]');
    if (activeBtn) activeBtn.classList.add('active');
    
    if (menu) {
      const activeItem = menu.querySelector('[data-tab-target="' + blockId + '"]');
      if (activeItem) {
        activeItem.classList.add('active');
        if (label) {
          const textSpan = activeItem.querySelector('span');
          label.textContent = textSpan ? textSpan.textContent : activeItem.textContent.trim();
        }
      }
    }
    
    const activePanel = content.querySelector('[data-tab-id="' + blockId + '"]');
    if (activePanel) activePanel.classList.add('active');
    
    // Atualizar hash da URL com slug amigável se solicitado
    if (updateHash !== false) {
      const tabs = window.ecInstitutionalTabs.getAll();
      const tabData = tabs[blockId] || {};
      const slug = generateSlug(tabData.title);
      window.location.hash = slug || blockId;
    }
  }

  function closeMobileDropdown(trigger, menu) {
    trigger.classList.remove('active');
    menu.classList.remove('active');
  }

  function initFAQAccordions() {
    const faqQuestions = document.querySelectorAll('.faq-item__question');
    
    faqQuestions.forEach(function(question) {
      question.addEventListener('click', function(e) {
        e.preventDefault();
        const faqItem = question.closest('.faq-item');
        
        if (!faqItem) return;
        
        faqItem.classList.toggle('active');
      });
    });
  }

  function findTabIdBySlug(slug) {
    const allTabs = window.ecInstitutionalTabs.getAll();
    
    // Procurar por uma aba que tenha o slug correspondente
    for (const blockId in allTabs) {
      const tabData = allTabs[blockId];
      const tabSlug = generateSlug(tabData.title);
      if (tabSlug === slug) {
        return blockId;
      }
    }
    
    return null;
  }

  function validateAndActivateTabFromHash() {
    const hash = window.location.hash.slice(1); // Remove #
    
    if (!hash) return;
    
    let blockId = null;
    
    // Primeiro, tentar encontrar pela slug amigável
    blockId = findTabIdBySlug(hash);
    
    // Se não found, tentar como blockId direto (compatibilidade com hashes antigos)
    if (!blockId) {
      const allTabs = window.ecInstitutionalTabs.getAll();
      if (allTabs[hash]) {
        blockId = hash;
      } else {
        return; // Hash não é válido
      }
    }
    
    // Encontrar a seção que contém este tab
    setTimeout(function() {
      const tabPanel = document.querySelector('[data-tab-id="' + blockId + '"]');
      if (!tabPanel) return;
      
      const section = tabPanel.closest('.ec-institutional-tabs');
      if (!section) return;
      
      // Ativar a aba sem atualizar o hash novamente
      handleTabChange(blockId, section, false);
      
      // Scroll opcional: você pode descomentar se quiser
      // tabPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  function initHashValidation() {
    // Ativar tab baseado no hash ao carregar a página
    validateAndActivateTabFromHash();
    
    // Detectar mudanças de hash e ativar tab correspondente
    window.addEventListener('hashchange', function() {
      validateAndActivateTabFromHash();
    });
  }

  function init() {
    initInstitutionalTabs();
    initHashValidation();
    initFAQAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
